module.exports = __webpack_public_path__ + "img/23.cd3172c1.jpg";